var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInPersonIconRed = function SvgInPersonIconRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-188.000000, -323.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "InPerson",
    transform: "translate(188.000000, 323.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Digital-Copy",
    transform: "translate(2.000000, 2.000000)",
    fill: "#FD5F55",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,18.328125 C14.359375,18.328125 17.96875,14.7109375 17.96875,10.359375 C17.96875,6 14.3515625,2.390625 9.9921875,2.390625 C5.640625,2.390625 2.03125,6 2.03125,10.359375 C2.03125,14.7109375 5.6484375,18.328125 10,18.328125 Z M10,17 C6.3125,17 3.3671875,14.046875 3.3671875,10.359375 C3.3671875,6.671875 6.3046875,3.71875 9.9921875,3.71875 C13.6796875,3.71875 16.6328125,6.671875 16.6406404,10.359375 C16.6484375,14.046875 13.6875,17 10,17 Z M9.9921875,10.1171875 C11.1015625,10.125 12,9.1796875 12,7.9296875 C12,6.7578125 11.1015625,5.78125 9.9921875,5.78125 C8.8828125,5.78125 7.984375,6.7578125 7.984375,7.9296875 C7.984375,9.1796875 8.8828125,10.109375 9.9921875,10.1171875 Z M13.5625,14.3203125 C13.875,14.3203125 14.0234375,14.1171875 14.0234375,13.828125 C14.0234375,12.9765625 12.734375,10.7578125 9.9921875,10.7578125 C7.25,10.7578125 5.9609375,12.9765625 5.9609375,13.828125 C5.9609375,14.1171875 6.109375,14.3203125 6.421875,14.3203125 L13.5625,14.3203125 Z",
    id: "\\uDBC1\\uDCE3"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInPersonIconRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/in-person-icon-red.e39ac1fa.svg";
export { ForwardRef as ReactComponent };